import styled from "styled-components";
import { Color, Text, Flex } from "src/elements";
import { sliceText } from "src/utils/sliceText";
import { useStatusModal } from "src/modals/StatusModal/store/hooks";

const ClickableStatus = styled(Flex)`
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: ${Color.primaryHover};
  }

  & > * {
    color: ${Color.primary};
    text-decoration: inherit;
  }

  &:hover > * {
    color: ${Color.primaryHover};
  }
`;

interface Props {
  status: string;
  title: string;
  maxLength?: number;
}

export const TruncatedStatusCell = ({ status, title, maxLength = 50 }: Props) => {
  const { openStatusModal } = useStatusModal();

  const isLongStatus = status.length > maxLength;
  const displayStatus = isLongStatus ? sliceText(status, maxLength) : status;

  const handleClick = () => {
    openStatusModal({
      title,
      content: status,
    });
  };

  if (isLongStatus) {
    return (
      <ClickableStatus onClick={handleClick}>
        <Text variant="small2">{displayStatus}</Text>
      </ClickableStatus>
    );
  }

  return <Text variant="small2">{displayStatus}</Text>;
};
